import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import CelebritiesDataTable from 'components/celebrities/CelebritiesDataTable';
import { convertQueryParamsIntoObject } from 'constant/Helpers';

const CelebritiesPage = () => {
  const [inputValues, setInputValues] = useState({
    page: 1,
  });
  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      setInputValues(queryObj);
    }
  }, []);

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      setInputValues(queryObj);
    }
  }, [location.search]);

  return (
    <div>
      <CelebritiesDataTable inputValues={inputValues} setInputValues={setInputValues} />
    </div>
  );
};

export default CelebritiesPage;
